import React, { createContext, useContext, useMemo, useState } from "react";

const LANGUAGE_OPTIONS = [
  { label: "English", value: "en" },
  { label: "हिन्दी (Hindi)", value: "hi" },
  { label: "Español (Spanish)", value: "es" },
  { label: "Français (French)", value: "fr" },
  { label: "Deutsch (German)", value: "de" },
  { label: "Português (Portuguese)", value: "pt" },
  { label: "Italiano (Italian)", value: "it" },
  { label: "العربية (Arabic)", value: "ar" },
  { label: "中文 (Chinese)", value: "zh" },
  { label: "日本語 (Japanese)", value: "ja" },
  { label: "한국어 (Korean)", value: "ko" },
  { label: "Русский (Russian)", value: "ru" },
  { label: "Türkçe (Turkish)", value: "tr" },
  { label: "Tiếng Việt (Vietnamese)", value: "vi" },
  { label: "Bahasa Indonesia", value: "id" },
  { label: "বাংলা (Bengali)", value: "bn" },
  { label: "தமிழ் (Tamil)", value: "ta" },
  { label: "తెలుగు (Telugu)", value: "te" },
  { label: "ಕನ್ನಡ (Kannada)", value: "kn" },
  { label: "मराठी (Marathi)", value: "mr" },
  { label: "ગુજરાતી (Gujarati)", value: "gu" },
  { label: "ਪੰਜਾਬੀ (Punjabi)", value: "pa" },
  { label: "اردو (Urdu)", value: "ur" },
  { label: "മലയാളം (Malayalam)", value: "ml" }
];

const dictionaries = {
  en: {
    navSearchPlaceholder: "Search services or categories",
    navLogin: "Login",
    navLanguage: "Change language",
    navHome: "Home",
    navCabBooking: "Cab Booking",
    navHomeServices: "Home Services",
    navProvider: "Become Provider",
    navDashboard: "Dashboard",
    footerAbout:
      "Trusted marketplace connecting consumers with verified service providers across home care, healthcare, travel, and business needs.",
    footerQuickLinks: "Quick Links",
    footerPolicies: "Policies",
    footerHelp: "Help Center",
    footerContactUs: "Contact Us",
    footerContactNumber: "+91 98765 43210",
    footerAddress: "4th Floor, Vyntez Towers, Whitefield, Bengaluru, Karnataka 560066, India",
    footerWebsite: "www.vyntez.com",
    footerRights: "All rights reserved.",
    chatLauncher: "VyntezChat",
    chatTitle: "VyntezChat Support",
    chatWelcome:
      "Hi! I'm VyntezChat. Live support is coming soon - for now check Help Center or Contact Us.",
    chatPlaceholder: "Type your message...",
    chatSend: "Send",
    chatComingSoon: "Chat replies are coming soon. Our team will connect this to live support shortly.",
    homeHeroTitle: "One platform for consumers and service providers",
    homeHeroSubtitle:
      "Book trusted professionals, compare options, and manage bookings in minutes across home care, healthcare, business, travel, and more.",
    homePillConsumer: "Consumer Services",
    homePillProvider: "Service Provider Platform",
    homePillCab: "Cab Booking",
    homePillMobile: "Mobile Friendly",
    homeStartBooking: "Start Booking",
    homeBecomeProvider: "Become Provider",
    homeHighlight1Title: "21 Service Categories",
    homeHighlight1Body: "From home services to digital experts and cab booking support.",
    homeHighlight2Title: "Consumer + Provider",
    homeHighlight2Body: "Single ecosystem for discovery, booking, and provider growth.",
    homeHighlight3Title: "Fast Phone Login",
    homeHighlight3Body: "Secure OTP login with first-time consent flow support.",
    homeHighlight4Title: "Responsive Experience",
    homeHighlight4Body: "Optimized for mobile-first usage with quick search and access.",
    homeServicesTitle: "Services Offered To Consumers",
    homeServicesMeta: "{{services}} services across {{categories}} categories",
    homeNoMatch: "No services matched your search.",
    homeViewDetails: "View Details",
    homeFooterTagline: "Trusted doorstep services for every family.",
    terms: "Terms and Condition",
    privacy: "Privacy Policy",
    companyLine: "Company Developed - Vyntez Solutions Pvt Ltd - vyntez.com",
    contactLine: "Contact Number - info@vyntezbuddy.com",
    dashboardTitle: "Consumer Dashboard",
    dashboardSubtitle: "Choose a category first, then pick a service to avoid confusion.",
    dashboardMetaCategories: "Categories",
    dashboardMetaServices: "Services",
    dashboardMetaCab: "Cab Booking Live",
    dashboardSearchCategory: "Category filter",
    dashboardBookNow: "Book now",
    dashboardQuickHeading: "Quick Overview",
    dashboardPopularHeading: "Popular Categories",
    dashboardServicesHeading: "Services in {{category}}",
    dashboardSelectCategory: "Select a category to view services",
    providerRegister: "Provider Register?",
    userMenuGreeting: "Hi, {{name}}",
    userProfile: "User Profile",
    settings: "Settings",
    subscriptionLater: "Subscription - Later",
    logout: "Logout",
    detailsBack: "Back",
    detailsLogin: "Login",
    detailsPillServices: "{{count}} Services",
    detailsPillVerified: "Verified Providers",
    detailsPillFast: "Fast Booking",
    detailsShowDetails: "Show Details",
    detailsSupportText:
      "Detailed booking support for {{service}} with provider discovery, transparent communication, and post-service assistance.",
    detailsServiceText:
      "Professional {{service}} solutions with quick response and quality assurance.",
    loginWelcome: "Welcome to Vyntez Buddy",
    loginPrompt: "Enter Phone Number to Login",
    loginCountry: "Country",
    loginPhone: "Phone Number",
    loginPhonePlaceholder: "Enter mobile number",
    loginOtp: "OTP",
    loginOtpPlaceholder: "Enter OTP",
    loginSendOtp: "Send OTP",
    loginSendingOtp: "Sending OTP...",
    loginResendOtp: "Resend OTP",
    loginResendIn: "Resend in {{timer}}",
    loginResendReady: "You can resend now",
    loginFirstTime: "First time user",
    loginAgreePrefix: "I agree to the",
    loginAgreePrivacy: "I agree to the Privacy Policy.",
    loginAgreeTerms: "I agree to the Terms and Condition.",
    loginSubmit: "Submit",
    loginVerifying: "Verifying..."
  },
  hi: {
    navSearchPlaceholder: "seva ya category search karein",
    navLogin: "login",
    navLanguage: "bhasha badlein",
    navHome: "home",
    navCabBooking: "cab booking",
    navHomeServices: "home services",
    navProvider: "provider banein",
    navDashboard: "dashboard",
    footerAbout:
      "Har seva ke liye trusted marketplace - home care, healthcare, travel aur business zarurat ke liye verified providers.",
    footerQuickLinks: "quick links",
    footerPolicies: "policies",
    footerHelp: "help center",
    footerContactUs: "contact karein",
    footerContactNumber: "+91 98765 43210",
    footerAddress: "4th Floor, Vyntez Towers, Whitefield, Bengaluru, Karnataka 560066, India",
    footerWebsite: "www.vyntez.com",
    footerRights: "sabhi adhikar surakshit.",
    chatLauncher: "VyntezChat",
    chatTitle: "VyntezChat Support",
    chatWelcome: "Namaste! main VyntezChat hoon. Live support jald aa raha hai - abhi Help Center ya Contact Us dekhein.",
    chatPlaceholder: "apna message likhein...",
    chatSend: "bhejein",
    chatComingSoon: "chat replies jald aa rahe hain. hamari team ise live support se jodegi.",
    homeHeroTitle: "consumer aur service provider ke liye ek platform",
    homeHeroSubtitle:
      "trusted professionals book karein, options compare karein, aur minutes mein booking manage karein.",
    homePillConsumer: "consumer services",
    homePillProvider: "service provider platform",
    homePillCab: "cab booking",
    homePillMobile: "mobile friendly",
    homeStartBooking: "booking shuru karein",
    homeBecomeProvider: "provider banein",
    homeHighlight1Title: "21 service categories",
    homeHighlight1Body: "home services se digital experts tak sab ek jagah.",
    homeHighlight2Title: "consumer + provider",
    homeHighlight2Body: "discovery, booking aur growth ke liye single ecosystem.",
    homeHighlight3Title: "fast phone login",
    homeHighlight3Body: "secure otp login with first-time consent flow.",
    homeHighlight4Title: "responsive experience",
    homeHighlight4Body: "mobile users ke liye clear aur fast flow.",
    homeServicesTitle: "consumers ke liye services",
    homeServicesMeta: "{{services}} services, {{categories}} categories mein",
    homeNoMatch: "aapki search se match karne wali service nahi mili.",
    homeViewDetails: "details dekhein",
    homeFooterTagline: "har parivar ke liye trusted doorstep services.",
    terms: "terms and condition",
    privacy: "privacy policy",
    companyLine: "Company Developed - Vyntez Solutions Pvt Ltd - vyntez.com",
    contactLine: "Contact Number - info@vyntezbuddy.com",
    dashboardTitle: "consumer dashboard",
    dashboardSubtitle: "pehle category chunein, phir service chunein. flow clear rahega.",
    dashboardMetaCategories: "categories",
    dashboardMetaServices: "services",
    dashboardMetaCab: "cab booking live",
    dashboardSearchCategory: "category filter",
    dashboardBookNow: "abhi book karein",
    dashboardQuickHeading: "quick overview",
    dashboardPopularHeading: "popular categories",
    dashboardServicesHeading: "{{category}} mein services",
    dashboardSelectCategory: "services dekhne ke liye category select karein",
    providerRegister: "provider register?",
    userMenuGreeting: "namaste, {{name}}",
    userProfile: "user profile",
    settings: "settings",
    subscriptionLater: "subscription - baad mein",
    logout: "logout",
    detailsBack: "wapas",
    detailsLogin: "login",
    detailsPillServices: "{{count}} services",
    detailsPillVerified: "verified providers",
    detailsPillFast: "fast booking",
    detailsShowDetails: "details dikhao",
    detailsSupportText:
      "{{service}} ke liye detailed booking support, provider discovery aur post-service assistance.",
    detailsServiceText: "professional {{service}} solutions with quick response and quality assurance.",
    loginWelcome: "vyntez buddy mein aapka swagat hai",
    loginPrompt: "login ke liye phone number darj karein",
    loginCountry: "country",
    loginPhone: "phone number",
    loginPhonePlaceholder: "mobile number darj karein",
    loginOtp: "otp",
    loginOtpPlaceholder: "otp darj karein",
    loginSendOtp: "otp bhejein",
    loginSendingOtp: "otp bheja ja raha hai...",
    loginResendOtp: "otp dobara bhejein",
    loginResendIn: "dobara bhejne mein {{timer}}",
    loginResendReady: "ab aap resend kar sakte hain",
    loginFirstTime: "first time user",
    loginAgreePrefix: "main sehmat hoon",
    loginAgreePrivacy: "main Privacy Policy se sehmat hoon.",
    loginAgreeTerms: "main Terms and Condition se sehmat hoon.",
    loginSubmit: "submit",
    loginVerifying: "verify ho raha hai..."
  }
};

const CORE_LANGUAGE_OVERRIDES = {
  es: {
    navSearchPlaceholder: "Buscar servicios o categorías",
    navLogin: "Iniciar sesión",
    navHome: "Inicio",
    navCabBooking: "Reserva de taxi",
    navHomeServices: "Servicios para el hogar",
    navProvider: "Ser proveedor",
    navDashboard: "Panel",
    terms: "Términos y condiciones",
    privacy: "Política de privacidad",
    footerHelp: "Centro de ayuda",
    footerContactUs: "Contáctenos",
    loginSendOtp: "Enviar OTP",
    loginSubmit: "Enviar",
    chatLauncher: "VyntezChat"
  },
  fr: {
    navSearchPlaceholder: "Rechercher des services ou catégories",
    navLogin: "Connexion",
    navHome: "Accueil",
    navCabBooking: "Réservation de taxi",
    navHomeServices: "Services à domicile",
    navProvider: "Devenir prestataire",
    navDashboard: "Tableau de bord",
    terms: "Conditions générales",
    privacy: "Politique de confidentialité",
    footerHelp: "Centre d'aide",
    footerContactUs: "Nous contacter",
    loginSendOtp: "Envoyer l'OTP",
    loginSubmit: "Soumettre",
    chatLauncher: "VyntezChat"
  },
  de: {
    navSearchPlaceholder: "Dienste oder Kategorien suchen",
    navLogin: "Anmelden",
    navHome: "Startseite",
    navCabBooking: "Taxibuchung",
    navHomeServices: "Haushaltsdienste",
    navProvider: "Anbieter werden",
    navDashboard: "Übersicht",
    terms: "Allgemeine Geschäftsbedingungen",
    privacy: "Datenschutzrichtlinie",
    footerHelp: "Hilfecenter",
    footerContactUs: "Kontaktieren Sie uns",
    loginSendOtp: "OTP senden",
    loginSubmit: "Absenden",
    chatLauncher: "VyntezChat"
  },
  pt: {
    navSearchPlaceholder: "Pesquisar serviços ou categorias",
    navLogin: "Entrar",
    navHome: "Início",
    navCabBooking: "Reserva de táxi",
    navHomeServices: "Serviços domésticos",
    navProvider: "Tornar-se fornecedor",
    navDashboard: "Painel",
    terms: "Termos e condições",
    privacy: "Política de privacidade",
    footerHelp: "Central de ajuda",
    footerContactUs: "Fale conosco",
    loginSendOtp: "Enviar OTP",
    loginSubmit: "Enviar",
    chatLauncher: "VyntezChat"
  },
  it: {
    navSearchPlaceholder: "Cerca servizi o categorie",
    navLogin: "Accedi",
    navHome: "Home",
    navCabBooking: "Prenotazione taxi",
    navHomeServices: "Servizi per la casa",
    navProvider: "Diventa fornitore",
    navDashboard: "Pannello",
    terms: "Termini e condizioni",
    privacy: "Informativa sulla privacy",
    footerHelp: "Centro assistenza",
    footerContactUs: "Contattaci",
    loginSendOtp: "Invia OTP",
    loginSubmit: "Invia",
    chatLauncher: "VyntezChat"
  },
  ar: {
    navSearchPlaceholder: "ابحث عن الخدمات أو الفئات",
    navLogin: "تسجيل الدخول",
    navHome: "الرئيسية",
    navCabBooking: "حجز سيارة أجرة",
    navHomeServices: "خدمات منزلية",
    navProvider: "كن مزودًا",
    navDashboard: "لوحة التحكم",
    terms: "الشروط والأحكام",
    privacy: "سياسة الخصوصية",
    footerHelp: "مركز المساعدة",
    footerContactUs: "اتصل بنا",
    loginSendOtp: "إرسال رمز التحقق",
    loginSubmit: "إرسال",
    chatLauncher: "VyntezChat"
  },
  zh: {
    navSearchPlaceholder: "搜索服务或类别",
    navLogin: "登录",
    navHome: "首页",
    navCabBooking: "打车预订",
    navHomeServices: "家庭服务",
    navProvider: "成为服务商",
    navDashboard: "控制台",
    terms: "条款和条件",
    privacy: "隐私政策",
    footerHelp: "帮助中心",
    footerContactUs: "联系我们",
    loginSendOtp: "发送验证码",
    loginSubmit: "提交",
    chatLauncher: "VyntezChat"
  },
  ja: {
    navSearchPlaceholder: "サービスやカテゴリを検索",
    navLogin: "ログイン",
    navHome: "ホーム",
    navCabBooking: "タクシー予約",
    navHomeServices: "家庭向けサービス",
    navProvider: "提供者になる",
    navDashboard: "ダッシュボード",
    terms: "利用規約",
    privacy: "プライバシーポリシー",
    footerHelp: "ヘルプセンター",
    footerContactUs: "お問い合わせ",
    loginSendOtp: "OTPを送信",
    loginSubmit: "送信",
    chatLauncher: "VyntezChat"
  },
  ko: {
    navSearchPlaceholder: "서비스 또는 카테고리 검색",
    navLogin: "로그인",
    navHome: "홈",
    navCabBooking: "택시 예약",
    navHomeServices: "홈 서비스",
    navProvider: "제공자 등록",
    navDashboard: "대시보드",
    terms: "이용약관",
    privacy: "개인정보 처리방침",
    footerHelp: "고객센터",
    footerContactUs: "문의하기",
    loginSendOtp: "OTP 전송",
    loginSubmit: "제출",
    chatLauncher: "VyntezChat"
  },
  ru: {
    navSearchPlaceholder: "Поиск услуг или категорий",
    navLogin: "Войти",
    navHome: "Главная",
    navCabBooking: "Заказ такси",
    navHomeServices: "Услуги на дому",
    navProvider: "Стать поставщиком",
    navDashboard: "Панель управления",
    terms: "Условия использования",
    privacy: "Политика конфиденциальности",
    footerHelp: "Центр помощи",
    footerContactUs: "Связаться с нами",
    loginSendOtp: "Отправить код",
    loginSubmit: "Отправить",
    chatLauncher: "VyntezChat"
  },
  tr: {
    navSearchPlaceholder: "Hizmet veya kategori ara",
    navLogin: "Giriş yap",
    navHome: "Ana sayfa",
    navCabBooking: "Taksi rezervasyonu",
    navHomeServices: "Ev hizmetleri",
    navProvider: "Sağlayıcı ol",
    navDashboard: "Panel",
    terms: "Şartlar ve koşullar",
    privacy: "Gizlilik politikası",
    footerHelp: "Yardım merkezi",
    footerContactUs: "Bize ulaşın",
    loginSendOtp: "OTP gönder",
    loginSubmit: "Gönder",
    chatLauncher: "VyntezChat"
  },
  vi: {
    navSearchPlaceholder: "Tìm kiếm dịch vụ hoặc danh mục",
    navLogin: "Đăng nhập",
    navHome: "Trang chủ",
    navCabBooking: "Đặt xe taxi",
    navHomeServices: "Dịch vụ gia đình",
    navProvider: "Trở thành nhà cung cấp",
    navDashboard: "Bảng điều khiển",
    terms: "Điều khoản và điều kiện",
    privacy: "Chính sách bảo mật",
    footerHelp: "Trung tâm trợ giúp",
    footerContactUs: "Liên hệ chúng tôi",
    loginSendOtp: "Gửi OTP",
    loginSubmit: "Gửi",
    chatLauncher: "VyntezChat"
  },
  id: {
    navSearchPlaceholder: "Cari layanan atau kategori",
    navLogin: "Masuk",
    navHome: "Beranda",
    navCabBooking: "Pemesanan taksi",
    navHomeServices: "Layanan rumah",
    navProvider: "Jadi penyedia",
    navDashboard: "Dasbor",
    terms: "Syarat dan ketentuan",
    privacy: "Kebijakan privasi",
    footerHelp: "Pusat bantuan",
    footerContactUs: "Hubungi kami",
    loginSendOtp: "Kirim OTP",
    loginSubmit: "Kirim",
    chatLauncher: "VyntezChat"
  },
  bn: {
    navSearchPlaceholder: "পরিষেবা বা বিভাগ খুঁজুন",
    navLogin: "লগইন",
    navHome: "হোম",
    navCabBooking: "ক্যাব বুকিং",
    navHomeServices: "হোম সার্ভিস",
    navProvider: "প্রোভাইডার হন",
    navDashboard: "ড্যাশবোর্ড",
    terms: "শর্তাবলী",
    privacy: "গোপনীয়তা নীতি",
    footerHelp: "সহায়তা কেন্দ্র",
    footerContactUs: "যোগাযোগ করুন",
    loginSendOtp: "OTP পাঠান",
    loginSubmit: "জমা দিন",
    chatLauncher: "VyntezChat"
  },
  ta: {
    navSearchPlaceholder: "சேவைகள் அல்லது வகைகளை தேடுங்கள்",
    navLogin: "உள்நுழைய",
    navHome: "முகப்பு",
    navCabBooking: "கேப் முன்பதிவு",
    navHomeServices: "வீட்டு சேவைகள்",
    navProvider: "வழங்குநராக மாறுங்கள்",
    navDashboard: "டாஷ்போர்டு",
    terms: "விதிமுறைகள் மற்றும் நிபந்தனைகள்",
    privacy: "தனியுரிமைக் கொள்கை",
    footerHelp: "உதவி மையம்",
    footerContactUs: "எங்களை தொடர்பு கொள்ள",
    loginSendOtp: "OTP அனுப்பு",
    loginSubmit: "சமர்ப்பிக்க",
    chatLauncher: "VyntezChat"
  },
  te: {
    navSearchPlaceholder: "సేవలు లేదా వర్గాలను వెతకండి",
    navLogin: "లాగిన్",
    navHome: "హోమ్",
    navCabBooking: "క్యాబ్ బుకింగ్",
    navHomeServices: "గృహ సేవలు",
    navProvider: "ప్రొవైడర్ అవ్వండి",
    navDashboard: "డాష్‌బోర్డ్",
    terms: "నిబంధనలు మరియు షరతులు",
    privacy: "గోప్యతా విధానం",
    footerHelp: "సహాయ కేంద్రం",
    footerContactUs: "మమ్మల్ని సంప్రదించండి",
    loginSendOtp: "OTP పంపండి",
    loginSubmit: "సమర్పించండి",
    chatLauncher: "VyntezChat"
  },
  kn: {
    navSearchPlaceholder: "ಸೇವೆಗಳು ಅಥವಾ ವರ್ಗಗಳನ್ನು ಹುಡುಕಿ",
    navLogin: "ಲಾಗಿನ್",
    navHome: "ಮುಖಪುಟ",
    navCabBooking: "ಕ್ಯಾಬ್ ಬುಕಿಂಗ್",
    navHomeServices: "ಮನೆ ಸೇವೆಗಳು",
    navProvider: "ಪೂರೈಕೆದಾರರಾಗಿ",
    navDashboard: "ಡ್ಯಾಶ್‌ಬೋರ್ಡ್",
    terms: "ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳು",
    privacy: "ಗೌಪ್ಯತಾ ನೀತಿ",
    footerHelp: "ಸಹಾಯ ಕೇಂದ್ರ",
    footerContactUs: "ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ",
    loginSendOtp: "OTP ಕಳುಹಿಸಿ",
    loginSubmit: "ಸಲ್ಲಿಸಿ",
    chatLauncher: "VyntezChat"
  },
  mr: {
    navSearchPlaceholder: "सेवा किंवा श्रेणी शोधा",
    navLogin: "लॉगिन",
    navHome: "मुख्यपृष्ठ",
    navCabBooking: "कॅब बुकिंग",
    navHomeServices: "घरगुती सेवा",
    navProvider: "पुरवठादार व्हा",
    navDashboard: "डॅशबोर्ड",
    terms: "अटी व शर्ती",
    privacy: "गोपनीयता धोरण",
    footerHelp: "मदत केंद्र",
    footerContactUs: "आमच्याशी संपर्क साधा",
    loginSendOtp: "OTP पाठवा",
    loginSubmit: "सबमिट करा",
    chatLauncher: "VyntezChat"
  },
  gu: {
    navSearchPlaceholder: "સેવાઓ અથવા શ્રેણીઓ શોધો",
    navLogin: "લોગિન",
    navHome: "હોમ",
    navCabBooking: "કેબ બુકિંગ",
    navHomeServices: "ઘર સેવાઓ",
    navProvider: "પ્રદાતા બનો",
    navDashboard: "ડેશબોર્ડ",
    terms: "નિયમો અને શરતો",
    privacy: "ગોપનીયતા નીતિ",
    footerHelp: "સહાય કેન્દ્ર",
    footerContactUs: "અમારો સંપર્ક કરો",
    loginSendOtp: "OTP મોકલો",
    loginSubmit: "સબમિટ કરો",
    chatLauncher: "VyntezChat"
  },
  pa: {
    navSearchPlaceholder: "ਸੇਵਾਵਾਂ ਜਾਂ ਸ਼੍ਰੇਣੀਆਂ ਖੋਜੋ",
    navLogin: "ਲਾਗਇਨ",
    navHome: "ਹੋਮ",
    navCabBooking: "ਕੈਬ ਬੁਕਿੰਗ",
    navHomeServices: "ਘਰੇਲੂ ਸੇਵਾਵਾਂ",
    navProvider: "ਪ੍ਰਦਾਤਾ ਬਣੋ",
    navDashboard: "ਡੈਸ਼ਬੋਰਡ",
    terms: "ਨਿਯਮ ਅਤੇ ਸ਼ਰਤਾਂ",
    privacy: "ਗੋਪਨੀਯਤਾ ਨੀਤੀ",
    footerHelp: "ਸਹਾਇਤਾ ਕੇਂਦਰ",
    footerContactUs: "ਸਾਡੇ ਨਾਲ ਸੰਪਰਕ ਕਰੋ",
    loginSendOtp: "OTP ਭੇਜੋ",
    loginSubmit: "ਜਮ੍ਹਾਂ ਕਰੋ",
    chatLauncher: "VyntezChat"
  },
  ur: {
    navSearchPlaceholder: "خدمات یا زمرے تلاش کریں",
    navLogin: "لاگ ان",
    navHome: "ہوم",
    navCabBooking: "کیب بکنگ",
    navHomeServices: "گھریلو خدمات",
    navProvider: "فراہم کنندہ بنیں",
    navDashboard: "ڈیش بورڈ",
    terms: "شرائط و ضوابط",
    privacy: "رازداری کی پالیسی",
    footerHelp: "مدد کا مرکز",
    footerContactUs: "ہم سے رابطہ کریں",
    loginSendOtp: "OTP بھیجیں",
    loginSubmit: "جمع کروائیں",
    chatLauncher: "VyntezChat"
  },
  ml: {
    navSearchPlaceholder: "സേവനങ്ങൾ അല്ലെങ്കിൽ വിഭാഗങ്ങൾ തിരയുക",
    navLogin: "ലോഗിൻ",
    navHome: "ഹോം",
    navCabBooking: "ക്യാബ് ബുക്കിംഗ്",
    navHomeServices: "ഹോം സേവനങ്ങൾ",
    navProvider: "പ്രൊവൈഡർ ആകുക",
    navDashboard: "ഡാഷ്ബോർഡ്",
    terms: "നിബന്ധനകളും വ്യവസ്ഥകളും",
    privacy: "സ്വകാര്യതാ നയം",
    footerHelp: "സഹായ കേന്ദ്രം",
    footerContactUs: "ഞങ്ങളെ ബന്ധപ്പെടുക",
    loginSendOtp: "OTP അയയ്ക്കുക",
    loginSubmit: "സമർപ്പിക്കുക",
    chatLauncher: "VyntezChat"
  }
};

Object.keys(CORE_LANGUAGE_OVERRIDES).forEach((code) => {
  dictionaries[code] = CORE_LANGUAGE_OVERRIDES[code];
});

const fallbackDictionary = dictionaries.en;
const LanguageContext = createContext(null);

const getDictionary = (language) => dictionaries[language] || fallbackDictionary;

const interpolate = (template, params) => {
  if (!params) {
    return template;
  }

  return Object.entries(params).reduce((acc, [key, value]) => {
    return acc.replace(new RegExp(`{{${key}}}`, "g"), String(value));
  }, template);
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => localStorage.getItem("vb-language") || "en");

  const api = useMemo(() => {
    const dictionary = getDictionary(language);

    return {
      language,
      options: LANGUAGE_OPTIONS,
      setLanguage: (nextLanguage) => {
        setLanguage(nextLanguage);
        localStorage.setItem("vb-language", nextLanguage);
      },
      t: (key, params) => {
        const template = dictionary[key] || fallbackDictionary[key] || key;
        return interpolate(template, params);
      }
    };
  }, [language]);

  return <LanguageContext.Provider value={api}>{children}</LanguageContext.Provider>;
};

export const useVBTranslation = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useVBTranslation must be used within LanguageProvider");
  }
  return context;
};
